<template>

    <div class="card" :class="messageVariantClass">
        <div class="card-body">
            <p class="my-0 font-weight-bold" @click="openDetails = !openDetails" style="cursor: pointer;">{{message.sender_name}}</p>
            <b-table v-if="openDetails" :borderless="true" :striped="true" :outlined="true" :small="true" :items="messageDetails"></b-table>

            <p class="text-muted small mb-3">{{message.date}}</p>
            <div v-html="message.body"></div>
            <b-button variant="outline" size="sm" v-if="!displayQuote && message.body_quoted"  @click="displayQuote=true" class="text-muted">
                <b-icon icon="plus" aria-hidden="true"></b-icon>
            </b-button>
            <div v-if="displayQuote" v-html="message.body_quoted"></div>
            <template v-for="attachment in message.attachments">
                <a :href="'/messages/' + message.id + '/attachments/' + attachment.id + '/' + attachment.name" target="_blank" class="badge badge-light">{{attachment.name}}</a>
            </template>
        </div>
    </div>

</template>

<script>
export default {
    name: "Message",
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            displayQuote: false,
            openDetails: false,
            messageDetails: []
        };
    },
    mounted() {
        let details = this.message
        this.messageDetails = [
            {field: 'Subject', value: details.subject},
            {field: 'To', value: details.to_identifier},
            {field: 'CC', value: details.cc},
            {field: 'From', value: details.from_identifier},
            {field: 'Reply-To', value: details.reply_to_identifier},
        ];
    },
    computed: {
        messageVariantClass() {
            return {
                'message-inbound': this.message.variant === 'inbound',
                'message-outbound': this.message.variant === 'outbound',
            };
        },
    },
}
</script>